import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap-5';

const statusToText = (status) => {
  return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
};

export const statusToClass = (status) => {
  if (status.includes('Expired')) return 'inactive';

  return status.toLowerCase().replace(/_/g, '-').replace(/ /g, '-');
};

const updateListingStatus = (status) => {
  switch (status) {
  case 'on_market':
    return 'active';
  case 'off_market':
    return 'inactive';
  default:
    return status;
  }
};

class Pill extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    // The caller's own words for the status. The color still follows status.
    label: PropTypes.string,
    status: PropTypes.string.isRequired
  };

  render() {
    const status = updateListingStatus(this.props.status);
    const labelClass = `label-${statusToClass(status)}`;
    const labelText = this.props.label ?? statusToText(status);
    const className = `px-4 rounded-pill text-uppercase ${labelClass} ${this.props.className}`;

    return <Badge className={className}>{labelText}</Badge>;
  }
}

class LabelWithDot extends React.Component {
  static propTypes = {
    status: PropTypes.string.isRequired
  };

  render() {
    const status = updateListingStatus(this.props.status);
    const labelClass = `label-text-${statusToClass(status)}`;

    return (
      <div className="d-flex gap-1 align-items-center">
        <span className={`dot label-${statusToClass(status)}`} />
        <span className={labelClass} name="label">
          {statusToText(status)}
        </span>
      </div>
    );
  }
}

class LabelAsSpan extends React.Component {
  static propTypes = {
    status: PropTypes.string.isRequired,
  };

  render() {
    const status = updateListingStatus(this.props.status);
    const labelClass = `label-text-${statusToClass(status)}`;

    return (
      <span className={labelClass} name="label-as-span">
        {statusToText(status)}
      </span>
    );
  }
}

const Status = {
  Pill,
  LabelAsSpan,
  LabelWithDot
};

export default Status;
